module.exports = __webpack_public_path__ + "images/create-first-board/card-back/cardBack-zh-hans.1bb7167a0e06e1cd57c9.svg";